import { styled } from '@mui/material/styles';
import SwitchMui from '@mui/material/Switch';

export const Switch = styled(SwitchMui)(({ theme }) => ({
	width: 56,
	height: 32,
	padding: 0,
	marginRight: 9,
	'& .MuiSwitch-switchBase': {
		padding: 0,
		margin: 1,
		transitionDuration: "300ms",
		"&.Mui-checked": {
			transform: "translateX(24px)",
			color: "#fff",
			"& + .MuiSwitch-track": {
				opacity: 1,
				border: 0,
			},
		},
		"&.Mui-disabled + .MuiSwitch-track": {
			backgroundColor: theme.palette.grey[400],
			opacity: 1,
		},
		"&.Mui-disabled .MuiSwitch-thumb": {
			color: theme.palette.common.white,
		},
	},
	'& .MuiSwitch-thumb': {
		boxSizing: "border-box",
		width: 30,
		height: 30,
	},
	'& .MuiSwitch-track': {
		borderRadius: 16,
		backgroundColor: theme.palette.grey[100],
		opacity: 1,
		transition: theme.transitions.create(["background-color"], {
			duration: 500,
		}),
	},
}));